import styled from "styled-components";

import { Breakpoint, Spacing } from "~/shared/styles";

export const FormGroupWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin: 0;
	min-height: 88px;
	padding: 0 ${Spacing.XS};
	width: 100%;

	@media screen and (${Breakpoint.DESKTOP}) {
		margin: 0.5rem 0;
		max-height: 166px;
	}
`;
